import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { LayoutPassword } from '../Components/LayoutPassword';
import { AskNewPassword } from '../Components/Password/NewPasswordComponent';
import { SendResetPassword } from '../Components/Password/ResetPasswordComponent';
import { AskUpdatePassword } from '../Components/Password/UpdatePasswordComponent';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { setPageContent } from '../Store/Layout/Actions';
import { ILayoutState } from '../Store/Layout/Types';
import { IUpdatePasswordState } from '../Store/UpdatePassword/Types';
import { IUserState } from '../Store/User/Types';

export interface IRouterMatchParams {
	type: string;
}

interface IPropsFromState {
	user: IUserState;
	router: RouteComponentProps<IRouterMatchParams>;
	layout: ILayoutState;
	updatePassword: IUpdatePasswordState;
}

interface IPropsFromDispatch {
	setPageContent: typeof setPageContent;
}

type AllProps = IPropsFromDispatch &
	IPropsFromState &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class PasswordPage extends React.Component<AllProps> {
	public constructor(props: AllProps) {
		super(props);
	}

	public render(): React.ReactNode {
		switch (this.props.router.match.params.type) {
			case 'reset':
				if (this.props.user.username === '') {
					this.props.setPageContent(
						<Route component={SendResetPassword} />
					);
				} else {
					return <Redirect to="/login" />;
				}
				break;
			case 'update_password':
				this.props.setPageContent(<Route component={AskNewPassword} />);
				break;
			case 'new_password':
				this.props.setPageContent(
					<Route component={AskUpdatePassword} />
				);
				break;
		}
		return <Route component={LayoutPassword} />;
	}
}

const mapStateToProps = (
	{ i18n, user }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
});

export const Password = connect(
	mapStateToProps,
	mapDispatchToProps
)(PasswordPage);
